import { WIZ_EVENT_TYPE, VALUE_ENTER } from '@wizeoo/akm-core-lib';
import {
  WizBasePopUp,
  WizValidationContainerDirective,
  WizTextInput,
  WizValidationErrors,
  WizFocusManager,
  WizValidatorFn,
  WizValidationError,
  WizEventManager, WizEvent
} from '@wizeoo/akm-component-lib';
import {
  Component,
  ChangeDetectionStrategy,
  ViewChild,
  ChangeDetectorRef,
  ElementRef,
  HostListener
} from '@angular/core';
import { ViewData } from '@wizeoo/akm-common-lib';
import { FreedataArgsVO } from '@wizeoo/akm-common-lib';
import { FreeDataVO } from '@wizeoo/akm-common-lib';

/**
 * PopUp de création d'un Arg sur FD: définition du code (unique)
 */
@Component({
  selector: 'arg-add-pop',
  templateUrl: './arg.add.pop.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ArgAddPop extends WizBasePopUp {
  @ViewChild(WizValidationContainerDirective, { read: WizValidationContainerDirective })
  private validationContainer: WizValidationContainerDirective;

  @ViewChild('tiCode', { read: WizTextInput, static: true }) tiCode: WizTextInput;

  constructor(public elementRef: ElementRef, private cdref: ChangeDetectorRef) {
    super();
  }

  public clone: FreeDataVO;
  public oldCode: string;
  
  private _isValidable: boolean = false;
  public get isValidable(): boolean {
    // activation du bouton de sauvegarde
    return this._isValidable;
  }

  // validation sur enter
  @HostListener('window:keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key === VALUE_ENTER && this.isValidable) {
      this.validate();
    }
  }

  show() {
    this.clone = this.datas[0];
    this.callback = this.datas[1];

    this.tiCode.wizRestrict = ViewData.CODE_REGEXP;
    this.tiCode.wizValue = null;
    // focus du premier champ
    WizFocusManager.getInstance().wizSetFocus(this.tiCode);

    WizEventManager.addListener(this, this, WIZ_EVENT_TYPE.MODEL_UPDATE, this.onModelUpdate);
  }

  onModelUpdate(e: WizEvent): void {

    const errors: WizValidationErrors = this.validationContainer.check(true);
    
    this._isValidable = !errors || errors.length === 0;
    // console.log('validable', this._isValidable, errors);
    this.cdref.markForCheck();
  }

  /**
   * Validateur d'unicité du code / shortCode
   */
   public uniqueArgCodeValidator(): WizValidatorFn {
    return (): WizValidationErrors | null => {
 
      if (this.tiCode.wizValue !== null && this.tiCode.wizValue && this.tiCode.wizValue.length > 0) {
        // CHRONO = mot réservé
        if (this.tiCode.wizValue.toUpperCase() === 'CHRONO') {
          const temp: WizValidationError = {
            wizError: '$.common.keyword.$',
            wizErrorParams: [],
          };
          return [temp];
        }

        // Recherche d'une autre codif avec le même code
        const otherArg: FreedataArgsVO = this.clone.getArgsVOMap().get(this.tiCode.wizValue.toUpperCase());
 
        // Si une codif existe deja avec le meme code on affiche le message
        if (otherArg) {
          const temp: WizValidationError = {
            wizError: '$.freedataarg.error.code.unique.$',
            wizErrorParams: [],
          };
          return [temp];
        }
      }
      return null;
    };
  }

  validate(): void {
    if (this.isValidable) {
      const newArgVO: FreedataArgsVO = this.clone.model.freedataEngine.createArg(this.clone);
      newArgVO.code = this.tiCode.wizValue?.toUpperCase();
      this.callback(newArgVO);
      this.hide();
    }
  }


  hide() {
    WizEventManager.removeListener(this, this, WIZ_EVENT_TYPE.MODEL_UPDATE);
    super.hide();
  }
}
